import envConfig from '@nile/home/src/Config/env';
import { postMessageToWails } from '../constants';

const takeSnapShot = ({ customHeaders, formData }) => {
  const agentProp = JSON.parse(sessionStorage.getItem('agentProperties'));
  postMessageToWails({
    eventName: 'TAKE_SCREENSHOT',
    data: {
      location: '',
      url: `${localStorage.getItem('apiDomain') + envConfig.fileRoot}/upload`,
      timeout: 300,
      httpMethod: 'POST',
      headers: {
        'asset-id': customHeaders?.AssetId || agentProp?.AssetId,
        'asset-token': customHeaders?.AssetToken || agentProp?.AssetToken,
        'app-acc': customHeaders?.AppAcc || agentProp?.AppAcc,
        reqType: 'assetUser'
      },
      formData: JSON.parse(JSON.stringify(formData))
    }
  });
};

async function takeScreenShot(callBack) {
  try {
    const stream = await navigator.mediaDevices.getDisplayMedia({
      video: { mediaSource: 'screen' }
    });

    const video = document.createElement('video');
    video.srcObject = stream;

    video.onloadedmetadata = () => {
      video.play();

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      const screenshotURL = canvas.toDataURL('image/png');

      stream.getTracks().forEach((track) => track.stop());

      if (callBack) callBack({ data: screenshotURL, error: null });
    };
  } catch (err) {
    console.error('Error capturing screen:', err);
  }
}

const convertDataURLToBlob = (dtaURL) => {
  const byteString = atob(dtaURL.split(',')[1]);
  const mimeString = dtaURL
    .split(',')[0]
    .split(':')[1]
    .split(';')[0];

  const byteArray = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    byteArray[i] = byteString.charCodeAt(i);
  }

  return new Blob([byteArray], { type: mimeString });
};

export { takeScreenShot, convertDataURLToBlob, takeSnapShot };
